export const CHECK_PERMISSION_REQUEST_SUCCESS = 'CHECK_PERMISSION_REQUEST_SUCCESS';
export const CHECK_PERMISSION_REQUEST_FAILURE = 'CHECK_PERMISSION_REQUEST_FAILURE';

export const CHECK_PERMISSION_FOR_VIEW_REQUEST = 'CHECK_PERMISSION_FOR_VIEW_REQUEST';
export const CHECK_PERMISSION_FOR_VIEW_REQUEST_SUCCESS = 'CHECK_PERMISSION_FOR_VIEW_REQUEST_SUCCESS';
export const CHECK_PERMISSION_FOR_VIEW_REQUEST_FAILURE = 'CHECK_PERMISSION_FOR_VIEW_REQUEST_FAILURE';

export const CHECK_PERMISSION_FOR_FIELD_REQUEST = 'CHECK_PERMISSION_FOR_FIELD_REQUEST';
export const CHECK_PERMISSION_FOR_FIELD_REQUEST_SUCCESS = 'CHECK_PERMISSION_FOR_FIELD_REQUEST_SUCCESS';
export const CHECK_PERMISSION_FOR_FIELD_REQUEST_FAILURE = 'CHECK_PERMISSION_FOR_FIELD_REQUEST_FAILURE';

export const CHECK_LAST_ROUTE_REQUEST = 'CHECK_LAST_ROUTE_REQUEST';
export const CHECK_LAST_ROUTE_REQUEST_SUCCESS = 'CHECK_LAST_ROUTE_REQUEST_SUCCESS';
export const CHECK_LAST_ROUTE_REQUEST_FAILURE = 'CHECK_LAST_ROUTE_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/App/redux/constants/check_last_route_and_permission.constants.js